<script>
	import Alert from './../componentes/Alert.svelte';
    import { onMount } from 'svelte';
    import { moneda, moneda4 } from '../scripts';
	import { createEventDispatcher } from 'svelte';

    export let factura=null;
    export let PagarButton=false;

	const dispatch = createEventDispatcher();

    let offcanvas=false;
    let bsOffcanvas=false;
    let offcanvasClose=false;

    let tipo='EFECTIVO';

    let disabled_efectivo=true;
    let disabled_tarjeta=true;
    let disabled_autorizacion=true;

    let input_tipo_efectivo=null;
    let input_descuento=null;
    let input_tipo_tarjeta=null;
    let input_autorizacion=null;
    let boton_pagar=null;

    let efectivo=0;
    let tarjeta=0;
    let autorizacion='';
    let cambio=0;

    let cargado=false;
    let error=false;

	onMount(async () => {
        bsOffcanvas = new bootstrap.Offcanvas(offcanvas)
        bsOffcanvas.show()
        offcanvas.addEventListener('hidden.bs.offcanvas', function () { dispatch('close', {}); })
        setTimeout(function() { cargado=true; },300)
	});    

    $:if(tipo) {
        if(cargado===true)
        {
            changeTipo()
            calcularCambio();
        } else {
            setTimeout(function() { 
                changeTipo() 
                calcularCambio();
            },500)
        }
    }

    $: if(efectivo) calcularCambio()
    $: if(tarjeta) calcularCambio()

    function calcularCambio()
    {
        let calculo=(parseFloat(efectivo)+parseFloat(tarjeta))-factura.total;
        cambio=(calculo>0)?calculo:0;
    }

    function changeTipo()
    {
        //factura.total=factura.total.toFixed(2);
        error=false;
        if(tipo=='EFECTIVO')
        {
            disabled_efectivo=false;
            disabled_tarjeta=true;
            disabled_autorizacion=true;

            efectivo=factura.total.toFixed(4);
            tarjeta=0;
            autorizacion='';

            setTimeout(function() { 
                input_tipo_efectivo.focus();
                input_tipo_efectivo.select();
            },100)
           
        } else if(tipo=='TARJETA') {
            disabled_efectivo=false;
            disabled_tarjeta=false;
            disabled_autorizacion=false;
            efectivo=0;
            tarjeta=factura.total.toFixed(4);
            autorizacion='';
            //factura.total
            setTimeout(function() { input_tipo_tarjeta.focus(); input_tipo_tarjeta.select(); },100)

        } else if(tipo=='CREDITO') {
            disabled_efectivo=true;
            disabled_tarjeta=true;
            disabled_autorizacion=true;
        }
    }

    function onlyNumbers(e,campo)
    {
        let charCode = (e.which) ? e.which : e.keyCode

        if ( (charCode<96 || charCode>105 ) && (charCode<48 || charCode>57 ) && charCode != 37  && charCode != 39 && charCode != 35 && charCode != 36 && charCode != 190 && charCode != 46 && charCode != 110 && charCode != 13 && charCode != 9 && charCode != 8)
        {
            e.preventDefault();
            return false;
        }
        if(charCode == 13){ enter(campo) }
        return true;
    }
    
    function enter(campo)
    {
        if(campo=='efectivo')
        {
            if(tipo=='EFECTIVO')
            {
                boton_pagar.focus();
            } else if(tipo=='TARJETA') {
                input_tipo_tarjeta.focus();
                input_tipo_tarjeta.select();
            }
            
        } else if(campo=='tarjeta') {
            input_autorizacion.focus();
            input_autorizacion.select();
        } else if(campo=='autorizacion') {
            boton_pagar.focus();
        }
    }

    function pagar()
    {
        PagarButton=false;
        let p_efectivo=parseFloat(efectivo).toFixed(4);
        let p_tarjeta=parseFloat(tarjeta).toFixed(4);
        let p_total=parseFloat(factura.total).toFixed(4);

        let calculo=(efectivo+tarjeta)-p_total;

        if(calculo<0)
        {
            error='Cantidad pagada es menor que el total.<br/>Faltan <strong>'+moneda(calculo*-1,'Q.')+' Quetzales</strong>';
            if(tipo=='EFECTIVO')
            {
                input_tipo_efectivo.focus();
                input_tipo_efectivo.select();
            } else if(tipo=='TARJETA') {
                input_tipo_tarjeta.focus();
                input_tipo_tarjeta.select();
            }            
        } else if(tipo=='TARJETA' && autorizacion.trim()=='') {
            error='Por favor ingrese la autorización del pago con tarjeta';
            input_autorizacion.focus();
            input_autorizacion.select();            
        } else {
            error=false;
            if(tipo=='EFECTIVO')
            {
                factura.formaPago='E';
            } else if(tipo=='TARJETA') {
                factura.formaPago='T';
            }            
            
            factura.efectivo=efectivo;
            factura.efectivo_real=efectivo-cambio;
            factura.tarjeta=tarjeta;
            factura.autorizacion_tarjeta=autorizacion;
            bsOffcanvas.hide()
            dispatch('pagar', {});
        }
        
    }

    let focusPagarButton=false;
    let classPagarButton=false;
    function focusPagar()
    {
        classPagarButton=true;
        focusPagarButton=true;
        setTimeout(function() { focusPagarButton=false; },100)
    }
    function blurPagar() { classPagarButton=false; }
    
    function actualizarTotales() {
        factura.descuento=parseFloat(factura.descuento);
        dispatch('update', {});        
        setTimeout(function(){  
            dispatch('update', {});
        }, 500);
        
    }

</script>

<!-- svelte-ignore a11y-label-has-associated-control -->
<div class="offcanvas offcanvas-end" style='width:400px;' bind:this={offcanvas} tabindex="-1" id="offcanvasPago" aria-labelledby="offcanvasPagoLabel">
    <div class="offcanvas-header">
      <h5 id="offcanvasRightLabel"><i class="bi bi-receipt-cutoff me-1"></i>PAGO</h5>
      <button type="button" bind:this={offcanvasClose} class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body pt-0">

        <div class="btn-group mb-3">
            <input type="radio" value='EFECTIVO' bind:group={tipo} class="btn-check" name="btnradio" id="btn_efectivo" autocomplete="off">
            <label class="btn btn-outline-success pt-3" for="btn_efectivo">
                <i class="bi bi-cash-coin h2"></i><br/>EFECTIVO
            </label>
          
            <input type="radio" value='TARJETA' bind:group={tipo} class="btn-check" name="btnradio" id="btn_tarjeta" autocomplete="off">
            <label class="btn btn-outline-success pt-3" for="btn_tarjeta">
                <i class="bi bi-credit-card h2"></i><br/>TARJETA
            </label>
          
            <input type="radio" value='CREDITO' bind:group={tipo} class="btn-check" name="btnradio" id="btn_credito" autocomplete="off" disabled>
            <label class="btn btn-outline-success pt-3" for="btn_credito">
                <i class="bi bi-person-circle h2"></i><br/>CRÉDITO
            </label>            
        </div>

        {#if error!==false}
        <Alert parpadea disableMarginBottom valign='top' lheight='2'>{@html error}</Alert>
        {/if}
        
        <div class='mt-4'>

            <div class='col-12 col-md-8 mb-2'>
                <label class='text-secondary'>DESCUENTO {factura.descuento}</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon1">Q.</span>
                    </div>
                    <input on:input={actualizarTotales} on:keydown={(e)=>onlyNumbers(e,'efectivo')} type="text" class="form-control" bind:value={factura.descuento} bind:this={input_descuento}>
                </div>                
            </div>            

            <div class='col-12 col-md-8 mb-4'>
                <label class='text-dark'>TOTAL A PAGAR</label>
                <h1><strong>{moneda4(factura.total,'Q.')}</strong></h1>
            </div>

            <div class='col-12 col-md-8 mb-2'>
                <label class='text-secondary'>CANTIDAD EFECTIVO</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon1">Q.</span>
                    </div>
                    <input on:keydown={(e)=>onlyNumbers(e,'efectivo')} type="text" class="form-control" bind:value={efectivo} bind:this={input_tipo_efectivo} checked disabled={disabled_efectivo}>
                </div>                
            </div>

            <div class='col-12 col-md-8 mb-2'>
                <label class='text-secondary'>CANTIDAD TARJETA</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon1">Q.</span>
                    </div>
                    <input  on:keydown={(e)=>onlyNumbers(e,'tarjeta')} type="text" class="form-control" bind:value={tarjeta} bind:this={input_tipo_tarjeta} disabled={disabled_tarjeta}>
                </div>                
            </div>            
            
            <div class='col-12 col-md-8 mb-2'>
                <label class='text-secondary'>CAMBIO</label>
                <h4><strong>{moneda(cambio,'Q.')}</strong></h4>
            </div>

            <div class='col-12 col-md-12 mb-2'>
                <label class='text-secondary'>AUTORIZACIÓN TARJETA</label>
                <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" id="basic-addon1">#</span>
                    </div>
                    <input  on:keydown={(e)=>onlyNumbers(e,'autorizacion')} type="text" class="form-control" bind:value={autorizacion} bind:this={input_autorizacion} disabled={disabled_autorizacion}>
                </div>                
            </div>

            <button type="button" class='btn mt-4 pe-4 ps-4 w-100' disabled={!PagarButton}
                on:focus={focusPagar}
                on:blur={blurPagar}
                bind:this={boton_pagar}
                on:click={()=>{if(focusPagarButton===false) pagar();}}
                class:btn-secondary={classPagarButton===false}
                class:btn-success={classPagarButton===true}
                >
                <h2 class='mb-0'><i class="bi bi-cash-stack me-1"></i> PAGAR</h2>
            </button>
        </div>
    </div>
</div>